import React from "react";
import { Card, Table, Spin, Button, message,Descriptions, Tag } from "antd"
import { withRouter } from "react-router-dom";
import definitions from "../../Util/AFIPdefinitions"
import { connect } from "react-redux"
import { allState as mapStateToProps, allDispatch as mapDispatchToProps} from "../../Redux/Selectors"
import { Auth, API } from "aws-amplify"
import moment from 'moment'


class InvoiceView extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            invoiceItems:null,
            factura: null,
            loading: true

        }
    }

    componentDidMount() {
        if (this.props.factura){
            this.setState({loading:false, factura:this.props.factura, invoiceItems:this.props.items})
        } else if (this.props.invoice_id === null || this.props.invoice_id === undefined){
            this.props.history.push('/')
        } else{
        Auth.currentSession()
            .then(response => {
                API.get(
                    'test',
                    '/root/invoices/'+ this.props.invoice_id,
                    {
                        headers: {
                            Authorization: response.getIdToken().getJwtToken()
                        }
                    }
                )
                    .then(response => {
                        if (response=== null){
                            this.props.history.push('/')
                        }
                        let i=0
                        let items = response.items.map(item =>{
                            item['key']=i
                            i++
                            return item
                        })
                        this.setState({ loading: false, factura: response, invoiceItems:items })
                    })
                    .catch(err => {
                        console.log(err)
                    this.props.history.push('/')})
            })
        }
    }

    render() {

        if (this.state.factura === null){

            return <Spin />

        }
        else {
            const color_aux = definitions.status.filter(value=>value.value === this.state.factura.estado)[0]


        let columns = [
            {
                title: "Codigo",
                dataIndex: "codigo",
                key: "codigo",
                align: "center"
            },
            {
                title: "Descripcion",
                dataIndex: "concepto",
                key: "concepto"
            },
            {
                title: "Cantidad",
                dataIndex: "cantidad",
                key: "cantidad",
                align:"center"
            },
            {
                title: "Precio Unit.",
                dataIndex: "precio",
                key: "precio",
                align:"right"
            },
            {
                title: "Precio Total",
                dataIndex: "total",
                align:"right",
                render: (text, record, index) => record.precio * record.cantidad

            },]


        return (



            <div>

                <h3>Comprobante Nº {this.state.factura.nroDeComprobante}</h3>

                <Card style={{ marginBottom: "10px" }}>
                    <Descriptions title={"Destinatario"}>
                    {
                            this.state.factura.tipoResponsable !== "consumidor-final" &&
                            <>
                                <Descriptions.Item label="Razón social"><b>{this.state.factura.razonSocialCliente}</b></Descriptions.Item>
                                <Descriptions.Item label={"Número de " + definitions.documento.filter(value=>value.value === this.state.factura.tipoDocumento)[0].name}><b>{this.state.factura.nroDocumento}</b></Descriptions.Item>
                            </>
                        }
                        <Descriptions.Item label="Tipo"><b>{definitions.comprobante.filter(value=>value.value === this.state.factura.tipoDeComprobante)[0].name}</b></Descriptions.Item>
                        <Descriptions.Item label="Condición Frente al IVA"><b>{this.state.factura.tipoResponsable}</b></Descriptions.Item>
                        <Descriptions.Item label="Fecha de Emision"><b>{moment(this.state.factura.fecha).format("DD/MM/YY")}</b></Descriptions.Item>
                        <Descriptions.Item label="Vencimiento para el pago"><b>{moment(this.state.factura.vencimientoPago).format("DD/MM/YY")}</b></Descriptions.Item>
                        <Descriptions.Item label="Estado de Factura"><Tag color={color_aux.color}>{color_aux.name}</Tag></Descriptions.Item>
                    </Descriptions>
                </Card>

                <Card style={{marginBottom:"10px"}}>
                    <Descriptions title={"Detalle de Productos/Servicios"}></Descriptions>

                    <Table
                        columns={columns}
                        dataSource={this.state.invoiceItems}
                        pagination={false}
                        loading={this.state.loading}
                        scroll={{ x: "max-content" }}
                    />
                </Card>

                <Card style={{ marginBottom: "10px" }}>
                    <Descriptions title={"Totales e Impuestos"}>
                        <Descriptions.Item label="Total Factura"><b>{"$ " + this.state.factura.importeTotal}</b></Descriptions.Item>
                        <Descriptions.Item label="Moneda"><b>{definitions.moneda.filter(value=>value.value === this.state.factura.moneda)[0].name}</b></Descriptions.Item>
                        <Descriptions.Item label="Vencimiento pago"><b>{moment(this.state.factura.vencimientoPago).format("DD/MM/YY")}</b></Descriptions.Item>
                        <Descriptions.Item label="Periodo Facturado"></Descriptions.Item>
                        <Descriptions.Item label="Desde"><b>{moment(this.state.factura.desde).format("DD/MM/YY")}</b></Descriptions.Item>
                        <Descriptions.Item label="Hasta"><b>{moment(this.state.factura.hasta).format("DD/MM/YY")}</b></Descriptions.Item>

                    </Descriptions>
                </Card>

{!this.props.hideButtons  ?
                <div className="steps-action">
                        {<Button type="primary" style={{marginleft:5, marginRight:5}}
                            onClick={()=>{
                                this.setState({loading:true})
                                Auth.currentSession()
                                    .then(response => {
                                        API.get(
                                            'test',
                                            '/pdf/'+this.state.factura.invoiceId,
                                            {
                                                headers: {
                                                    Authorization: response.getIdToken().getJwtToken()
                                                },
                                                queryStringParameters:{
                                                    user_id:this.props.login.user_data.user_id
                                                }
                                            }
                                        )
                                            .then(response => {
                                                this.setState({ loading: false})
                                                var byteCharacters = atob(response['pdf']);
                                                var byteNumbers = new Array(byteCharacters.length);
                                                for (var i = 0; i < byteCharacters.length; i++) {
                                                  byteNumbers[i] = byteCharacters.charCodeAt(i);
                                                }
                                                var byteArray = new Uint8Array(byteNumbers);
                                                var file = new Blob([byteArray], { type: 'application/pdf;base64' });
                                                var fileURL = URL.createObjectURL(file);
                                                window.open(fileURL)
                                            })

                                            .catch(err => {
                                                message.error('Error generando PDF')
                                                this.setState({loading:false})
                                                console.log(err)})
                                    })
                              }} >

                        Ver PDF

                        </Button>}

                        {<Button type="primary" style={{marginleft:5, marginRight:5}}
                        disabled={!(this.state.factura.estado == 'DRAFT' || this.state.factura.estado == 'PRESENTED')}
                            onClick={()=>
                                Auth.currentSession()
                                .then(session => {
                                    API.put(
                                        'test',
                                        '/root/invoices/'+this.state.factura.invoiceId,
                                        {
                                            headers: {
                                                Authorization: session.getIdToken().getJwtToken()
                                            },
                                            body: {
                                                    tipoDeComprobante: this.state.factura.tipoDeComprobante,
                                                    nroDeComprobante: this.state.factura.numeroComprobante,
                                                    fecha: this.state.factura.fecha,
                                                    tipoResponsable: this.state.factura.tipoResponsable,
                                                    tipoDocumento: this.state.factura.tipoDocumento,
                                                    nroDocumento: this.state.factura.nroDocumento,
                                                    razonSocialCliente: this.state.factura.razonSocial,
                                                    domicilioComercialCliente: this.state.factura.domicilioComercial,
                                                    localidadCliente:this.state.factura.localidad,
                                                    provinciaCliente:this.state.factura.provincia,
                                                    emailCliente: this.state.factura.email,
                                                    formaDePago: this.state.factura.formaDePago,
                                                    moneda: this.state.factura.moneda,
                                                    concepto: this.state.factura.concepto,
                                                    desde: this.state.factura.desde,
                                                    hasta: this.state.factura.hasta,
                                                    vencimientoPago: this.state.factura.vencimientoPago,
                                                    items: this.state.factura.items,
                                                    observacion: this.state.factura.observacion,
                                                    estado:'PENDING_AFIP',
                                                    importeTotal:this.state.factura.importeTotal,
                                                    action:'PROCESS'

                                            }
                                        }
                                    )
                                    .then(response => {
                                        message.success("Factura enviada correctamente")
                                        this.setState({loading:false})
                                    })
                                    .catch(err => {
                                        message.error("Hubo un error enviando la factura")
                                        console.log(err)
                                        this.setState({ loading: false })
                                    })
                                })} >

                        Procesar Factura

                        </Button>}

                        {<Button type="primary" style={{marginleft:5, marginRight:5}}
                        disabled={this.state.factura.estado !== 'DRAFT' || this.state.factura.estado == 'PRESENTED'}
                            onClick={()=>
                                Auth.currentSession()
                                .then(session => {
                                    API.del(
                                        'test',
                                        '/root/invoices/'+this.state.factura.invoiceId,
                                        {
                                            headers: {
                                                Authorization: session.getIdToken().getJwtToken()
                                            },
                                        }
                                    )
                                    .then(response => {
                                        message.success("Comprobante eliminado correctamente")
                                        this.props.history.push('/facturas-emitidas')
                                    })
                                    .catch(err => {
                                        message.error("Hubo un error eliminando la factura")

                                    })
                                })} >

                        Eliminar Factura

                        </Button>}


                </div>:null}
            </div>)



    }
}



}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(InvoiceView));
